import React from 'react';
import Header from './Header.jsx';
import './Header.css';
import './Community.css'; 
import { useState, useEffect } from 'react';
import PostingList from './PostingList.jsx';
import Default from '../assets/default_pfp.png';
import { Link } from 'react-router-dom';
import translations from "./translation.js";
import CensorProfanity from './ProfanityCensor';

const Community = (appRefresh) => {

    const [posts, setPosts] = useState([]);
    const [members, setMembers] = useState([]);
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoadingMembers, setIsLoadingMembers] = useState(true);
    const [isMember, setIsMember] = useState(false);
    const [username, setUsername] = useState("");
    const [groupID, setGroupID] = useState(null);
    const [communityID, setCommunityID] = useState(null);
    const [userID, setUserID] = useState(null);
    const  currentLanguage = localStorage.getItem("selectedLanguage") || "en";
    const [community, setCommunity] = useState("");
    const [filteredPosts, setFilteredPosts] = useState([]);
    const [val, setVal] = useState("");
    const handleValue = (val) => { setVal(val); };
    const [profanityFilter, setProfanityFilter] = useState(false);

    useEffect(() => {
      filterPosts();
    }, [val, posts]);
  
    const filterPosts = () => {
      if (val !== null && val !== '' && val !== '@') {
        let filteredPosts = posts.filter(post => {
          if (val.startsWith('@')) {
            const usernameFilter = val.slice(1).toLowerCase();
            return post.author && post.author.attributes && post.author.attributes.username &&
                   post.author.attributes.username.toLowerCase().includes(usernameFilter);
          } else {
            return post.content.toLowerCase().includes(val.toLowerCase()) ||
                   post.attributes.title.toLowerCase().includes(val.toLowerCase());
          }
        });
        setFilteredPosts(filteredPosts);
      } else {
        setFilteredPosts(posts);
      }
    };

    const loadCommunity = () => {
        const hostname = window.location.href;
        const parts = hostname.split('/');
        console.log(parts[parts.length - 1]);
        if (parts[parts.length - 1]==="fps"){
            setCommunity("community1");
            setCommunityID(69);
            return 69;
        }
        else if (parts[parts.length - 1]==="battle-royale"){
            setCommunity("community2");
            setCommunityID(70);
            return 70;
        }
        else if (parts[parts.length - 1]==="moba"){
            setCommunity("community3");
            setCommunityID(73);
            return 73;
        }
        else if (parts[parts.length - 1]==="sandbox"){  
            setCommunity("community4");
            setCommunityID(71);
            return 71;
        }
        else if (parts[parts.length - 1]==="action-adventure"){
            setCommunity("community5");
            setCommunityID(72);
            return 72;
        }
        else{
            window.location.href = "/*";
            return ;
        }
    }
    const loadPosts = () => {
      const temp = loadCommunity();

      if (sessionStorage.getItem("token")) {
  
        fetch(`${process.env.REACT_APP_API_PATH}/posts?recipientGroupID=${temp}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          })
          .then((res) => res.json())
          .then((result) => {
            if (result) {
              console.log("result",result);
              setIsLoaded(true);
              setPosts(result[0].filter(post => !post.attributes.hidden));
            }
          })
          .catch((err) => {
            setIsLoaded(true);
            setError(err);
            console.log("ERROR loading posts");
          });
      }
    };
  
    const loadGroupMembers = async () => {
      const temp = loadCommunity();
      if (sessionStorage.getItem("token")) {
        try {
          
          const response = await fetch(`${process.env.REACT_APP_API_PATH}/group-members?groupID=${temp}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          });
  
          if (response.ok) {
            const data = await response.json();
            if (data && data[0]) {
              setMembers(data[0]);
            }
          } else {
            throw new Error("Failed to load group members");
          }
        } catch (err) {
          setError(err);
          console.log("ERROR loading group members");
        } finally {
          setIsLoadingMembers(false);
        }
      }
    };
  
    const fetchUserData = async () => {
      try {
        const userResponse = await fetch(
          `${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem('user')}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
          }
        );
  
        if (userResponse.ok) {
          const userResult = await userResponse.json();
          console.log(userResult);
          setUsername(userResult.attributes.username);
          setUserID(userResult.id);
          setProfanityFilter(userResult.attributes.ProfanityFilter)
        } else {
          console.error('Failed to fetch user data');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
  
    const checkMembership = () => {
      console.log(`Members array length: ${members.length}`);
      console.log('Members array:', members);
      
      const member = members.find(member => {
        console.log(`Checking username: ${member.user.attributes.username}`);
        return member.user.attributes.username === username;
      });
  
      if (member) {
        setIsMember(true);
        setGroupID(member.id);
        console.log(`User is a member of group ${groupID}`);
      } else {
        setIsMember(false);
        console.log("User is not a member of any group");
      }
    };
    
    
    useEffect(() => {
        loadCommunity();
        fetchUserData();
        loadPosts();
        loadGroupMembers();
        fetchUserData();
    }, []);
  
    useEffect(() => {
      if (members.length > 0) {
        checkMembership();
      }
    }, [members]);
  
    if (!isLoaded || isLoadingMembers) {
      return <div>Loading...</div>;
    }
  
    if (error) {
      return <div>Error: {error.message}</div>;
    }
  
    const buttonText = isMember ? translations[currentLanguage].leave_community : translations[currentLanguage].join_community;
    console.log(community);
    const handleButtonClick = () => {
      if (isMember) {
          //logic to leave community
          fetch(`${process.env.REACT_APP_API_PATH}/group-members/${groupID}`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
              }
            })
            .then(response => {
              if (response.ok) {
                console.log(`Successfully deleted group member with groupID: ${groupID}`);
              } else {
                console.error('Failed to delete group member');
              }
            })
            .catch(error => console.error('Error:', error));
          console.log("Left the community");
          setIsMember(false);
      } else {
          //logic to join community

          const data = {
              "userID": userID,
              "groupID": communityID,
              "attributes": {
                "additionalProp1": {}
              }
            };
            
            fetch(`${process.env.REACT_APP_API_PATH}/group-members`, {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            })
            .then(response => {
              if (response.ok) {
                console.log('Successfully added group member');
              } else {
                console.error('Failed to add group member');
              }
            })
            .catch(error => console.error('Error:', error));
        console.log("Joined the community");
        setIsMember(true);
      }
      window.location.reload();
    };

    const CensorProfanity = (text) => {
      console.log("pro:",profanityFilter);
      console.log(text);
      if (!profanityFilter) {
        return text;
      }
      // Replace profane words with asterisks or other characters
      return text.replace(/\b(fuck|hell|shit|bitch)\b/gi, "****");
    };

    return (
        <div className="feed-container">
    
      <Header onValue={handleValue}/>
          
          {/* !!!!!!!! CHANGE GROUP INFO !!!!!!!!!!!!!! */}
          <h1>{translations[currentLanguage][community]} {translations[currentLanguage].community}</h1>
    
          <div className="content-container">
            <main>
                <PostingList
                    refresh={appRefresh}
                    posts={filteredPosts.map(post => ({
                      ...post,
                      content: CensorProfanity(post.content)
                    }))}
                    error={error}
                    isLoaded={isLoaded}
                    type="postlist"
                    loadPosts={loadPosts}
                />
            <Link to="/postform"><button id="make-post-btn">+ {translations[currentLanguage].make_post}</button></Link>
            </main>
    
            <aside className='community'>
                <div className='info'>
    
                {/* !!!!!!!! CHANGE GROUP INFO !!!!!!!!!!!!!! */}
    
                <h1 className="heading">{translations[currentLanguage][community]}</h1>
                    <div className="yellow-box">
    
                    {/* !!!!!!!! CHANGE GROUP INFO !!!!!!!!!!!!!! */}
    
                        <p>
                        {translations[currentLanguage][`${community}_text`]}
                        </p>
                    </div>
                </div>
    
                <div className='join'>
                    <h1 className="heading">{translations[currentLanguage].interest}</h1>
                    <button 
                        className='yellow-box' 
                        style={{marginTop: "2%", fontSize: "20px"}} 
                        onClick={handleButtonClick}
                    >
                    {buttonText}
                    </button>
                </div>
    
                <div className='member-info'>
              <h1 className="heading">{translations[currentLanguage].members}</h1>
              <div style={{marginTop: "2%", overflow: "hidden" }}>
              <div style={{maxHeight: "100vh", overflowY: "auto" }}>
                {members.map((member) => (
                  <div key={member.user.id} style={{ backgroundColor: '#d1b140', padding: '10px', marginBottom: '10px', display: 'flex', alignItems: 'center', borderRadius: '10px' }}>
                    <Link to={`/user/${member.user.id}`} style={{ textDecoration: 'none' }}>
                        <img
                            src={member.user.attributes.picture || Default}
                            alt={member.user.attributes.username}
                            style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '10px' }}
                        />
                    </Link>
                    <span>
                        <Link to={`/user/${member.user.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                            @{member.user.attributes.username}
                        </Link>
                    </span>
                  </div>
                  ))}
              </div>
              </div>
            </div>
    
            </aside>
    
            </div>
    
          </div>
      );
    };


export default Community;
